// These are non-standard styles that must conform to
// the structure expected by react-notification-system.
// https://github.com/igorprado/react-notification-system#styles

import { Shadows, Colors, Dimensions } from '../../theme'

export default {
  Containers: {
    DefaultStyle: {
      width: 500,
      position: 'fixed',
      top: '45vh'
    },
    tc: {
      marginLeft: -(500 / 2)
    }
  },
  NotificationItem: {
    DefaultStyle: {
      width: 500,
      boxShadow: Shadows.primaryShadow,
      padding: 15,
      borderRadius: Dimensions.primaryBorderRadius
    },
    tc: {
      marginLeft: -(500 / 2)
    },
    error: {
      borderTop: '0px none',
      background: Colors.Palette.primaryColor,
      textAlign: 'center',
      color: 'white',
      fontSize: '1rem'
    },
    success: {
      borderTop: '0px none',
      background: Colors.Palette.successColor,
      textAlign: 'center',
      color: 'white',
      fontSize: '1rem'
    }
  },
  Title: {
    DefaultStyle: {
      fontWeight: 'normal',
      textAlign: 'center',
      color: 'white',
      fontSize: '1rem'
    }
  },
  Dismiss: {
    success: {
      color: Colors.Palette.successColor,
      backgroundColor: 'rgba(0,0,0,0)',
      fontSize: '1rem'
    },
    error: {
      color: ' #99042E',
      backgroundColor: 'rgba(0,0,0,0)',
      fontSize: '1rem'
    }
  }
}



// WEBPACK FOOTER //
// ./src/styles/components/react-notification-system.js